<template>
  <va-show :item="item">
    <va-field source="id"></va-field>
    <va-field v-slot="{ value }" source="scopes">
      <base-Scopes-selector :scopes="value" />
    </va-field>
  </va-show>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: () => ({}) },
  },
};
</script>
